import { SalesOrderStatus } from '../constants/sales-order-status.js';
import { SALES_ORDER_NOT_CANCELLABLE_MESSAGE } from './sales-order-not-cancellable-message.js';
import { SHIPPED_ORDER_CANCEL_MESSAGE } from './shipped-order-cancel-message.js';
// Cancelled is absent: a repeat cancel is a no-op (N15).
const NEVER_CANCELLABLE_STATUS_IDS = new Set([
    SalesOrderStatus.DELIVERED,
    SalesOrderStatus.COMPLETE,
    SalesOrderStatus.REJECTED,
]);
/** A Standard order at Shipped is cancelled only through Failed Delivery; a Drop Ship or Credit Return at Shipped cancels as at Accepted. */
export function salesOrderCancelRefusal({ statusId, path, }) {
    if (NEVER_CANCELLABLE_STATUS_IDS.has(statusId))
        return SALES_ORDER_NOT_CANCELLABLE_MESSAGE;
    if (statusId === SalesOrderStatus.SHIPPED && path === 'Standard') {
        return SHIPPED_ORDER_CANCEL_MESSAGE;
    }
    return null;
}
//# sourceMappingURL=sales-order-cancel-refusal.js.map